<template>
    <div>
        <bannerCenter
                :box="box"
                :isShowBot="isShowBot"
                :isShowBottom="isShowBottom"
        ></bannerCenter>
        <div class="newStatus_thr_message">
            <div class="newStatus_text">致合作伙伴的一封信</div>
            <div class="newStatus_time">发布时间：2022-11-05</div>
            <div class="newStatus_title">
                <div class="newStatus_title_text">
                    <div>各位尊敬的合作伙伴：</div>
                    <div class="textIndex">大家好，我是逍遥推手CEO王爱军。</div>
                    <div class="textIndex">借公众号“pos支付圈爆料”一篇文章“电银产品加收68元服务费，甩锅”跟大家做一个汇报与交流。文章核心意思是逍遥推手乱收费，然后甩锅给支付公司。</div>
                    <div class="textIndex">关于平台电银产品做以下几点陈述：</div>
                    <div class="textIndex">1、平台8月底上线电银这款产品；</div>
                    <div class="textIndex">2、平台对电银这款产品做了限售；</div>
                    <div class="textIndex">3、电银这款产品，平台累计入网仅仅几千台；</div>
                    <div class="textIndex">4、目前除了服务费问题，还有“入网困难，数据推送不及时”等问题；</div>
                    <div class="textIndex">所有公司都有自己的甲方公司，逍遥推手也不例外，平台在此次选品环节确实出现了重大失误，行业乱象，甲方难选，官品，一包，二包，甚至三包，十年支付人都难以区分。平台也在第一时间做出了停止售卖等动作。</div>
                    <div class="textIndex">作为媒体人，应该实事求是，追根溯源，而不是为了广告费，欲盖弥彰，混淆视听。各行各业都有各自的问题大疫三年，实属不易，积极传播正能量乃正道。不管当下你是谁，哪怕是一个小小的自媒体，拥抱正确的价值观，你才能走的更远，飞的更高，支付路不易，创业路更不易，一起加油，共勉！平台会保留诉讼权利！</div>
                    <div class="textIndex">“电银事件”的几点感受：1、平台选品的谨慎度还不够，未来选品要谨慎再谨慎，对每一位合作伙伴的职业生涯尽心尽责；2、强大自身是硬道理，努力成长为越来越有实力的乙方；3、行业乱象，选品难度极高，更加确定了聚合是未来；4、同样的产品动荡，对聚合联盟平台的总交易量不会产生任何影响。</div>
                    <div class="textIndex">创业路上，充满了未知，变幻莫测。平台永远都有坦然面对任何问题的勇气，平台也会一直保持对每一位合作伙伴负责的担当。不忘初心，方得始终！</div>
                    <div class="textIndex">大疫三年，平台尽到了一个中小企业的使命，责任，担当。近万个家庭，在平台上通过努力，收获了果实，渡过了疫情难关。我们会继续一如既往地努力，且更加努力地践行以“稳定”为核心价值观的战略！</div>
                    <div class="textIndex">近几个月，整个行业人心惶惶。我们一直在努力传递积极思维。我们所有逍遥人不焦虑，不迷茫，不抱怨，用我们的脚踏实地，在近几个月的时间里，商户入网数量和平台总交易量月月突飞猛进！我们不害怕被针对，我们更关心的是逍遥人要脚踏实地！</div>
                    <div class="textIndex">荆有棘，又何惧，披荆斩棘壮雄心，无可惧！</div>
                    <div class="textIndex">在此强烈呼吁所有的逍遥人，一起点亮我们的灯，同时也不要吹灭别人的灯，一个成熟的创业者，不诋毁他人是基本素养，脚踏实地做好自己！</div>
                    <div class="textIndex">逍遥人，一起奔跑吧！！</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bannerCenter from '../../components/bannerCenter'
    export default {
        data(){
            return{
                box:{
                    boxText:'',
                },
                isShowBot:false,
                isShowBottom:true
            }
        },
        components:{
            bannerCenter
        }
    }
</script>

<style lang="less" scoped>
    .newStatus_thr_message{
        background: #ffffff;
        padding-bottom: 40px;
        .newStatus_text{
            font-size: 22px;
            font-family: "Microsoft YaHei";
            font-weight: bold;
            color: #010101;
            text-align: center;
            padding: 20px 0 7px;
        }
        .newStatus_time{
            font-size: 14px;
            font-family:"Microsoft YaHei";
            font-weight: 400;
            color: #909090;
            text-align: center;
        }
        .newStatus_title{
            width: 570px;
            font-size: 10px;
            color: #000000;
            margin: 10px auto 0;
            .newStatus_title_text{
                line-height: 25px;
                .textIndex{
                    text-indent: 24px;
                }
            }
        }
    }
</style>
